// Hardcoded brand groups (add or edit as necessary)
export const isSpecialBrandsForLocale: (brandId: string) => boolean = (brandId: string) => {
    let specialBrandsForLocale = false;
    //for maden hotels brand
    if (brandId === '9248e3ae-75b8-418c-8b30-e1b13da4892a' || process.env.NODE_ENV === 'development') {
        specialBrandsForLocale = true;
    }
    return specialBrandsForLocale;
};

export const brandsNotAllowedToOpenInNewTab: (brandId: string) => boolean = (brandId: string) => {
    let brandsNotAllowedToOpenInNewTab = false;
    //for maden hotels brand, shada hotels brand and redwaves hotels brand
    if (brandId === '9248e3ae-75b8-418c-8b30-e1b13da4892a' || brandId === 'c15c7cc9-c0fa-4c7f-aa0f-271335dd3ac2' ) {
        brandsNotAllowedToOpenInNewTab = true;
    }
    return brandsNotAllowedToOpenInNewTab;
};


